import React from "react"
import {
  Email, CalculateOutlined, DateRange,
  FileCopyOutlined, FolderCopyOutlined,
  GavelOutlined, InsertDriveFileOutlined,
  TextSnippetOutlined, Phone, SettingsPhone, 
} from "@mui/icons-material";
import logo from '../Images/logo.svg'
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const data = [
  {
    id: 1,
    name: 'online_appeals',
    icon: <InsertDriveFileOutlined />,
    link: '/electron-filing'
  },
  {
    id: 2,
    name: 'request_copies',
    icon: <FileCopyOutlined />,
    link: '/act-request'
  },
  {
    id: 3,
    name: 'collection_decisions',
    icon: <TextSnippetOutlined />,
    link: '/collection-decisions'
  },
  {
    id: 5,
    name: 'calculator',
    icon: <CalculateOutlined />,
    link: '/calculator'
  },
  {
    id: 6,
    name: 'document_sample',
    icon: <FolderCopyOutlined />,
    link: '/document-sample-list'
  },
  {
    id: 8,
    name: 'sale',
    icon: <GavelOutlined />,
    link: '/sale'
  },
]

const Footer = () => {
  const { t } = useTranslation()
  return (
    <div className="sticky w-full dark:border-t 
                    dark:border-t-dark-border">
      <section className="grid md:grid-cols-2 lg:grid-cols-4 py-8 gap-8
                          xl:gap-16 bg-primary dark:bg-dark-box 
                          text-white dark:text-dark-text media">
        <Link to='/'>
          <ul className="flex gap-2 items-center h-max">
            <img
              src={logo}
              alt="logo"
              className="w-16 object-contain"
            />
            <h1>{t('supreme_court')} <br /> {t('turkmenistan')}</h1>
          </ul>
        </Link>
        <ul>
          <li className="font-bold mb-4">{t('online_services')}</li>
          {data?.map((d) => (
            <li key={d.id} className="mb-3">
              <Link to={d.link} className='flex gap-2'>
                <span style={{ fontSize: '18px' }}>
                  {d.icon}
                </span>
                {t(d.name)}
              </Link>
            </li>
          ))}
        </ul>

        <ul>
          <li className="font-bold mb-4">{t('receiving_citizens')}</li>
          <li className="flex gap-2 mb-3">
            <DateRange style={{ fontSize: '18px', marginTop: '2px' }} />
            {t('receiving_time_days')}
          </li>
          {/* <li className="mb-3">{t('receiving_time_week')}</li>
          <li className="mb-3">{t('break_time')}</li> */}

          <li className="font-bold mb-4 mt-6">Email</li>
          <li className="flex gap-2 mb-3">
            <Email style={{ fontSize: '18px', marginTop: '2px' }} />
            <a href="mailto:yokarykazyyet@court.gov.tm">yokarykazyyet@court.gov.tm</a>
          </li>
        </ul>

        <ul>
          <li className="font-bold mb-4">{t('number_inquiries')}</li>
          <li className="flex gap-2 mb-3">
            <Phone style={{ fontSize: '18px', marginTop: '2px' }} />
            <a href="tel:+993(12) 38-09-32">+993(12) 38-09-32</a>
          </li>
          <li className="flex gap-2 mb-3">
            <SettingsPhone style={{ fontSize: '18px', marginTop: '2px' }} />
            <a href="tel:+993(12) 92-02-01">+993(12) 92-02-01</a>
          </li>

          {/* <li className="flex gap-2 mb-3">
            <Headphones style={{ fontSize: '18px', marginTop: '2px' }} />
            <a href="mailto:yokarykazyyet@court.gov.tm">{t('write_admin')}</a>
          </li> */}
        </ul>
        <ul>

        </ul>
      </section>

      <section className="py-6 px-10 bg-primary text-white text-center 
                          dark:bg-dark-box dark:text-dark-text">
        Copyright &copy;
        {(new Date().getFullYear())}
        <span className="font-bold">
          {t('rights_reserved')} Privacy Policy
        </span>
      </section>
    </div>
  )
}

export default Footer;